import { LoadStatus } from '@capital-access/common/utils';
import { AccountUsers } from '../models/account-users';

export const ACCOUNT_USERS_FEATURE_KEY = 'common.user.company-contacts';

export interface AccountUsersState {
  users: AccountUsers[];
  loadStatus: LoadStatus;
  error?: unknown;
}
